import AdminUserDetail from './AdminUserDetail'
export default AdminUserDetail
